import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";

import './dropDownMenu.scss';

function DropDownMenuMyOrders(props) {
  const [click, setClick] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => setClick(!click);
  const pageLanguageContents = props.content
  const userType = localStorage.getItem('accountType')
  const storedData = useSelector((state) => state.storedData.payload)
  let disableFlg = storedData?.guestUser

  let menuItems = [
    {
      title: 'My Orders',
      path: '/my-orders',
      cName: 'dropdown-link'
    },
    {
      title: 'My Pickup Orders',
      path: '/my-pickup-orders',
      cName: 'dropdown-link'
    }
  ]

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {menuItems.map((item, index) => {
          return (
            <>{index === 0 && disableFlg ?
              <li key={index}>
                <div className='opacityDisable'>
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </div>
              </li> :
              <li key={index}>
                <Link
                  className={item.cName}
                  exact
                  to={item.path}
                  onClick={() => { }}
                >
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </Link>
              </li>}
            </>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenuMyOrders;